export enum View360CardTab {
    GENERAL_INFORMATION,
    EMPLOYEES,
    SALES,
    NOTES,
}
